import accounts from './accounts'
import reportTemplates from './report-templates'

const me = {
    accounts: Object.assign(accounts, accounts),
    reportTemplates: Object.assign(reportTemplates, reportTemplates),
}

export default me